
import { User, Bot, Check, Loader2 } from 'lucide-react';

type Props = {
 personality:any,
 personalities: any,
 setSaving:any,
 selectedPersonality: any,
 setSelectedPersonality:any,
 user: any
}
export const Personality = ({personality, personalities, setSaving, selectedPersonality, setSelectedPersonality, user}: Props) => {

    const savePersonality = async (personalityId) => {
        if (!user) return;

        setSaving(true);
        try {
          // Guardar en localStorage
          const data = {
            userId: user.id,
            personalityId: personalityId,
            timestamp: new Date().toISOString()
          };
          localStorage.setItem(`user_personality:${user.id}`, JSON.stringify(data));

          setSelectedPersonality(personalityId);

          // Enviar datos al bot
          const tg = window.Telegram?.WebApp;
          if (tg) {
            try { tg.ready(); } catch {}
            const personality = personalities.find(p => p.id === personalityId);
            tg.sendData(JSON.stringify({
              action: 'personality_selected',
              userId: user.id,
              personalityId: personalityId,
              prompt: personality?.prompt
            }));
            // Mantener abierta la WebApp para seguir usando otras funciones
            try { tg.expand(); } catch {}
          } else {
            alert('Personalidad guardada localmente (modo demo)');
          }
        } catch (error) {
            console.error('Error guardando personalidad:', error);
            alert('Error al guardar la personalidad');
        } finally {
            setSaving(false);
        }
    };
    
    return ( 
        <div
              onClick={() => savePersonality(personality.id)}
              className={`bg-white rounded-xl shadow-md p-5 cursor-pointer transition-all duration-200 hover:shadow-xl hover:scale-[1.02] ${
                selectedPersonality === personality.id
                  ? 'ring-4 ring-blue-500'
                  : ''
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div
                    className={`w-14 h-14 ${personality.color} rounded-xl flex items-center justify-center text-3xl`}
                  >
                    {personality.emoji}
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
                      {personality.name}
                      {selectedPersonality === personality.id && (
                        <Check className="w-5 h-5 text-green-500" />
                      )}
                    </h3>
                    <p className="text-gray-600 text-sm">
                      {personality.description}
                    </p>
                  </div>
                </div>
                <Bot className="w-6 h-6 text-gray-400" />
              </div>
            </div>
    );
}
